import React from "react";
import Lottie from "lottie-react";
import loading from "lotties/loading";


const Loading = () =>
<Lottie animationData={loading} loop={true} />;

export default Loading